import moment from "moment";
import { useEffect, useState } from "react";
import RigthArrow from "../../../assets/icon/rightArrowIcon";
import AGButtonV2 from "../../../components/ButtonV2";
import AGCheckbox from "../../../components/Checkbox";
import { useNavigateWithSearchParams } from "../../../hook/navigate";
import { ComOfferingSecondmentInterestType, SearchCommerceFirmDataRes, SearchServiceLevelDataRes } from "../../../models";
import { API_CONSTANT, INTEREST_TYPE, ITEM_LIST_LEVEL } from "../../../utils/constant";
import {
    Container,
    Logo,
    Right
} from "../searchItem.styled";
import { ServiceItemType } from "../searchService.props";
export interface SearchItemProps {
    checked: boolean;
    data?: SearchCommerceFirmDataRes;
    dataService?: SearchServiceLevelDataRes;
    itemLevel?: ITEM_LIST_LEVEL;
    onSelect: (checked: boolean) => void;
    isMobileDevice: boolean;
    hasTag?: boolean;
    selectedRecords?: any;
    tabType?: ServiceItemType;
    onSaveHistory?: (data?: any) => void;
    keyIndex?: number;
    isVendor?: boolean;
}

export const SearchItemV2 = ({
    checked,
    data,
    onSelect,
    isMobileDevice,
    hasTag = false,
    tabType,
    selectedRecords,
    onSaveHistory,
    keyIndex,
    isVendor,
    dataService,
    itemLevel = ITEM_LIST_LEVEL.FIRM
}: SearchItemProps) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth - 100);
    const dropTagOnDesktopBreakPointWidth = 924 // 1024-100
    const apiDomain = process.env.REACT_APP_API_DOMAIN;
    const [handleNavigate] = useNavigateWithSearchParams();
    const handleLinkServiceOfFirm = async (type?: string) => {
        if (onSaveHistory) onSaveHistory({
            tab: type ?? "",
            name: "handleLinkServiceOfFirm"
        });
        const idFirm = (itemLevel === ITEM_LIST_LEVEL.FIRM ? data : dataService)?.firmID
        handleNavigate(`/commerceProfile/${idFirm}`, {
            tab: type ?? ""
        });
    };

    const handleLinkServiceOfService = async (type?: string, e?: number) => {
        if (onSaveHistory) onSaveHistory({
            tab: type ?? 'service',
            serviceId: e ? e?.toString() : "",
            name: "handleLinkServiceOfService"
        });
        const idFirm = (itemLevel === ITEM_LIST_LEVEL.FIRM ? data : dataService)?.firmID
        handleNavigate(`/commerceProfile/${idFirm}`, {
            tab: type ?? 'service',
            serviceId: e ? e?.toString() : "",
        });
    };

    const getDataBuyLevel = (service: any, firm: any) => {
        return itemLevel === ITEM_LIST_LEVEL.SERVICE ? service : firm
    }

    const defaultLogo = data?.firmLogo;
    const logoUrl = getDataBuyLevel(dataService?.service.offerorLogoUrl?.split("?")?.[0], data?.firmProfile?.logoPart);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth - 150);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const getInterestTypesById = (interestTypes: ComOfferingSecondmentInterestType[]) => {
        return interestTypes.reduce((acc, curr, index) => {
            const types = {
                [INTEREST_TYPE.OFFERING]: "O",
                [INTEREST_TYPE.SEEKING]: "S"
            }[curr.fksecondmentInterestTypeId ?? INTEREST_TYPE.OFFERING]
            return `${acc}${index === 0 ? "" : "/"}${types ?? ""}`
        }, "")
    }
    const getShowMoreData = () => {
        if (!tabType) return 4;

        const limits = {
            [ServiceItemType.SERVICE]: 4,
            [ServiceItemType.PRODUCT]: 4,
            [ServiceItemType.SECONDMENT]: 3,
            [ServiceItemType.FIRM]: 4
        };
        return limits[tabType] || 4;
    }

    return (
        <Container className=" !p-[20px] !mb-[10px] bg-white last:!mb-0 !rounded-[10px] sizeFixedMobile:!rounded-none">
            <div className="flex !flex-nowrap w-full">
                <div className="!items-start !justify-between mr-[10px] ">
                    <AGCheckbox
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            onSelect(e.target.checked);
                        }}
                        value={checked ? checked.toString() : ""}
                    />

                </div >
                <Right className="!gap-0 flex-1 ">
                    <div className="flex flex-col ">
                        <div className="flex items-start w-full">
                            <Logo className="cursor-pointer !min-w-[42px] !min-h-[42px] !max-w-[42px] !max-h-[42px] mr-[20px]"
                                onClick={() => {
                                    itemLevel === ITEM_LIST_LEVEL.FIRM ?
                                        handleLinkServiceOfFirm("home") :
                                        handleLinkServiceOfService((tabType ?? "service").toLowerCase(), dataService?.service.comOfferingId)
                                }}
                            >
                                {logoUrl ? (
                                    <img
                                        src={`${apiDomain}${API_CONSTANT.DEFAULT_PROFILE.IMG
                                            }${encodeURIComponent(logoUrl)}`}
                                        alt="logo"
                                        className="w-full h-full object-contain"
                                    />
                                ) : defaultLogo ? (
                                    <img src={defaultLogo} alt="logo"
                                        className="w-full h-full object-contain"
                                    />
                                ) : null}
                            </Logo>
                            <div className="w-full">

                                <div className="flex flex-col">
                                    <div className="flex justify-between">
                                        <h2
                                            onClick={() => {
                                                itemLevel === ITEM_LIST_LEVEL.FIRM ?
                                                    handleLinkServiceOfFirm("home") :
                                                    handleLinkServiceOfService((tabType ?? "service").toLowerCase(), dataService?.service.comOfferingId)
                                            }}
                                            className="font-bold underline hover:cursor-pointer text-[#333333]"
                                        >
                                            {getDataBuyLevel(dataService?.service.title, data?.firmName)}
                                        </h2>
                                        {
                                            (!isMobileDevice && screenWidth >= dropTagOnDesktopBreakPointWidth) ?

                                                <div className="flex justify-end">
                                                    {
                                                        hasTag ?
                                                            <span className="h-[26px] bg-[#0971A2] text-white text-[11px] ml-[5px] font-medium py-[5px] px-[10px] rounded-[5px] uppercase text-nowrap mb-[2px]">
                                                                SPONSORED
                                                            </span>
                                                            : null
                                                    }
                                                    {
                                                        isVendor ?
                                                            <span className="h-[26px] bg-[#333333] text-white text-[11px] ml-[5px] font-medium py-[5px] px-[10px] rounded-[5px] uppercase text-nowrap">
                                                                {getDataBuyLevel(dataService?.vendorName?.trim(), data?.vendorName?.trim())}
                                                            </span>
                                                            : null
                                                    }
                                                </div>
                                                : null
                                        }
                                    </div>

                                    {tabType !== ServiceItemType.PRODUCT ? getDataBuyLevel(
                                        <p className="text-[12px] text-[#333333]">
                                            {dataService?.service.tagLine}
                                        </p>
                                        ,
                                        <p className="text-[12px] text-[#333333]">
                                            {data?.firmAddress?.city}
                                            {data?.province === "__"
                                                ? ""
                                                : ", " + data?.province}, {data?.firmAddress?.country}
                                        </p>)
                                        : !isMobileDevice && hasTag ?
                                            <>
                                                {screenWidth < dropTagOnDesktopBreakPointWidth ?
                                                    <div className="mt-[5px] mb-[10px]">
                                                        {
                                                            hasTag ?
                                                                <span className="h-[26px] bg-[#0971A2] text-white text-[11px] mr-[5px] font-medium py-[5px] px-[10px] rounded-[5px]">
                                                                    SPONSORED
                                                                </span>
                                                                : null
                                                        }
                                                        {
                                                            isVendor ?
                                                                <span className="h-[26px] bg-[#333333] text-white text-[11px]  font-medium py-[5px] px-[10px] rounded-[5px] uppercase">
                                                                    {getDataBuyLevel(dataService?.vendorName?.trim(), data?.vendorName?.trim())}
                                                                </span>
                                                                : null
                                                        }
                                                    </div>
                                                    : null}
                                                <p className="text-[#03A100] text-[12px] font-normal ">
                                                    {
                                                        getDataBuyLevel(
                                                            dataService?.service.sponsorMessage
                                                            ,
                                                            data?.services?.filter(e => e.sponsorMessage && (e.sponsorStartDate && e.sponsorEndDate
                                                                && moment(new Date()).isSameOrAfter(moment(e.sponsorStartDate).format("YYYY-MM-DD"), 'day')
                                                                && moment(new Date()).isBefore(moment(e.sponsorEndDate).format("YYYY-MM-DD"), 'day')
                                                            ))
                                                                ?.[0]?.sponsorMessage
                                                        )
                                                    }
                                                </p>
                                            </>
                                            : null
                                    }
                                </div>
                                {
                                    isMobileDevice ?
                                        <div className="ml-auto mt-[5px] ">
                                            {
                                                hasTag ?
                                                    <span className="h-[26px] bg-[#0971A2] text-white text-[11px] mr-[5px] font-medium py-[5px] px-[10px] rounded-[5px]">
                                                        SPONSORED
                                                    </span>
                                                    : null
                                            }
                                            {
                                                isVendor ?
                                                    <span className="h-[26px] bg-[#333333] text-white text-[11px]  font-medium py-[5px] px-[10px] rounded-[5px] uppercase">
                                                        {getDataBuyLevel(dataService?.vendorName?.trim(), data?.vendorName?.trim())}
                                                    </span>
                                                    : null
                                            }
                                        </div>
                                        : null
                                }

                                {
                                    isMobileDevice && hasTag ?
                                        <p className="text-[#03A100] text-[12px] font-normal mt-[5px]">


                                            {
                                                getDataBuyLevel(
                                                    dataService?.service.sponsorMessage
                                                    ,
                                                    data?.services?.filter(e => e.sponsorMessage && (e.sponsorStartDate && e.sponsorEndDate
                                                        && moment(new Date()).isSameOrAfter(moment(e.sponsorStartDate).format("YYYY-MM-DD"), 'day')
                                                        && moment(new Date()).isBefore(moment(e.sponsorEndDate).format("YYYY-MM-DD"), 'day')
                                                    ))
                                                        ?.[0]?.sponsorMessage
                                                )
                                            }
                                        </p>
                                        : null
                                }

                                {
                                    tabType !== ServiceItemType.PRODUCT && !isMobileDevice && hasTag ?
                                        <>
                                            {screenWidth < dropTagOnDesktopBreakPointWidth ?
                                                <div className="mt-[5px] mb-[10px]">
                                                    {
                                                        hasTag ?
                                                            <span className="h-[26px] bg-[#0971A2] text-white text-[11px] mr-[5px] font-medium py-[5px] px-[10px] rounded-[5px]">
                                                                SPONSORED
                                                            </span>
                                                            : null
                                                    }
                                                    {
                                                        isVendor ?
                                                            <span className="h-[26px] bg-[#333333] text-white text-[11px]  font-medium py-[5px] px-[10px] rounded-[5px] uppercase">
                                                                {getDataBuyLevel(dataService?.vendorName?.trim(), data?.vendorName?.trim())}
                                                            </span>
                                                            : null
                                                    }
                                                </div>
                                                : null}
                                            <p className="text-[#03A100] text-[12px] font-normal mt-[5px]">
                                                {
                                                    getDataBuyLevel(
                                                        dataService?.service.sponsorMessage
                                                        ,
                                                        data?.services?.filter(e => e.sponsorMessage && (e.sponsorStartDate && e.sponsorEndDate
                                                            && moment(new Date()).isSameOrAfter(moment(e.sponsorStartDate).format("YYYY-MM-DD"), 'day')
                                                            && moment(new Date()).isBefore(moment(e.sponsorEndDate).format("YYYY-MM-DD"), 'day')
                                                        ))
                                                            ?.[0]?.sponsorMessage
                                                    )
                                                }
                                            </p>
                                        </>
                                        : null
                                }

                                {
                                    tabType === ServiceItemType.PRODUCT && getDataBuyLevel(
                                        <p className="text-[12px] mt-[5px] text-[#333333]">
                                            {dataService?.service.tagLine}
                                        </p>
                                        ,
                                        <p className="text-[12px] text-[#333333]">
                                            {data?.firmAddress?.city}
                                            {data?.province === "__"
                                                ? ""
                                                : ", " + data?.province}, {data?.firmAddress?.country}
                                        </p>
                                    )
                                }
                                <p className="text-[#333333] text-[12px] mt-[5px] line-clamp-2">
                                    {
                                        getDataBuyLevel(
                                            dataService?.service.detailedDescription && dataService?.service.detailedDescription.length > 200
                                                ? `${dataService?.service.detailedDescription.substring(0, 200)}...`
                                                : dataService?.service.detailedDescription
                                            ,
                                            data?.firmProfile?.description && data?.firmProfile.description.length > 200
                                                ? `${data?.firmProfile?.description.substring(0, 200)}...`
                                                : data?.firmProfile?.description
                                        )


                                    }
                                </p>
                            </div>
                        </div>
                        {
                            itemLevel === ITEM_LIST_LEVEL.FIRM && isMobileDevice ? null :
                                <div className={`${tabType === ServiceItemType.FIRM ? `` : `max-w-full`} flex flex-row justify-start items-center overflow-x-auto flex-nowrap no-scrollbar-disable mt-[20px]`}
                                    style=
                                    {{
                                        ...(screenWidth < 1024 ? { width: `${screenWidth - 340}px` } : {})
                                    }}>
                                    {
                                        tabType === ServiceItemType.FIRM && data?.offeringCountData?.map((e, index) => (
                                            <AGButtonV2
                                                iconRight={
                                                    <RigthArrow className="ml-[10px] group-hover:fill-white fill-[#0971A2]" />
                                                }
                                                onClick={() => handleLinkServiceOfFirm(e.offeringType?.offeringTypeName?.split(" ").join("").toLowerCase() || "")}
                                            >
                                                <p className={`text-[12px] font-normal text-[#0971A2] group-hover:text-white group-hover:bg-[#0971A2]  truncate max-w-[137px]`}>
                                                    <span className="font-bold">{e.offeringCount}</span> {" "}
                                                    {e.offeringType?.offeringTypeName}{(e.offeringCount && e.offeringCount > 1) && 's'}
                                                </p>
                                            </AGButtonV2>
                                        ))}

                                    <div className={`flex overflow-x-auto whitespace-nowrap no-scrollbar-disable`}
                                        style={{
                                            ...(screenWidth < 1024 ? { width: `${screenWidth - 340}px` } : {})
                                        }}
                                    >
                                        {
                                            (tabType === ServiceItemType.SERVICE || tabType === ServiceItemType.PRODUCT) && data?.services?.sort((a, b) => {
                                                return a.comOfferingPracticeLevels?.[0]
                                                    ? a.comOfferingPracticeLevels?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName.localeCompare(b.comOfferingPracticeLevels?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName)
                                                    : a.comOfferingProductSecondaryServices?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName.localeCompare(b.comOfferingProductSecondaryServices?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName);
                                            }).slice(0, 4).map((e, index) => (
                                                <AGButtonV2
                                                    key={index}
                                                    iconRight={
                                                        <RigthArrow className="ml-[4px] group-hover:fill-white fill-[#0971A2]" />
                                                    }
                                                    witdh="137px"
                                                    minWidth="137px"
                                                    onClick={() => {
                                                        handleLinkServiceOfService((tabType ?? "service").toLowerCase(), e.comOfferingPracticeLevels?.[0]?.fkComOfferingId ?? e.comOfferingProductSecondaryServices?.[0]?.fkComOfferingId)
                                                    }
                                                    }
                                                    title={e.comOfferingPracticeLevels?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName ?? e.comOfferingProductSecondaryServices?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName}
                                                >
                                                    <p className={`text-[12px] font-normal text-[#0971A2] group-hover:text-white group-hover:bg-[#0971A2]  truncate max-w-[137px]`}>
                                                        {e.comOfferingPracticeLevels?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName ?? e.comOfferingProductSecondaryServices?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName}
                                                    </p>
                                                </AGButtonV2>
                                            ))
                                        }
                                        {
                                            (tabType === ServiceItemType.SECONDMENT) && data?.services?.slice(0, getShowMoreData()).map((e, index) => (
                                                <AGButtonV2
                                                    key={index}
                                                    iconRight={
                                                        <RigthArrow className=" group-hover:fill-white fill-[#0971A2]" />
                                                    }
                                                    witdh="220px"
                                                    minWidth="220px"
                                                    onClick={() => {
                                                        handleLinkServiceOfService((tabType ?? "service").toLowerCase(), e.comOfferingSecondments?.[0]?.fkComOfferingId)
                                                    }
                                                    }
                                                    cusInterestType={true}
                                                    title={e.title}
                                                >
                                                    <div className="absolute flex items-center justify-center left-[8px] ">
                                                        <p className="text-[12px] w-[20px] font-bold text-center align-middle">
                                                            {getInterestTypesById(e.comOfferingSecondmentInterestTypes ?? [])}
                                                        </p>
                                                        <span className="border-l border-[#0971A2] h-9 ml-[5px] group-hover:border-white" style={{ minHeight: 36 }}></span>
                                                    </div>
                                                    <p className={`ml-[20px] w-[200px] text-[12px] font-normal text-[#0971A2] group-hover:text-white group-hover:bg-[#0971A2] flex min-w-0 items-center justify-center`}>
                                                        <span className="truncate min-w-0 flex-shrink-0 max-w-[100%] text-center text-justify text-right">{e.title}</span>
                                                    </p>
                                                </AGButtonV2>
                                            ))
                                        }
                                    </div>

                                    {
                                        (tabType === ServiceItemType.SERVICE || tabType === ServiceItemType.PRODUCT || tabType === ServiceItemType.SECONDMENT) && data?.services && data?.services?.length > getShowMoreData() ? (
                                            <button
                                                className=" text-[12px] text-[#333333] underline text-nowrap pl-[10px]"
                                                onClick={() => {
                                                    handleLinkServiceOfFirm(tabType)
                                                }}
                                            >
                                                Show {data?.services?.length - getShowMoreData()} more
                                            </button>
                                        ) : null
                                    }
                                </div>
                        }
                    </div>

                </Right>
            </div>

            {
                itemLevel === ITEM_LIST_LEVEL.FIRM && isMobileDevice ?
                    <div className={`col-right !mt-[20px]`} style={{
                        width: screenWidth
                    }}>
                        <div className="flex flex-row justify-start items-center overflow-x-auto flex-nowrap no-scrollbar-disable">
                            {
                                tabType === ServiceItemType.FIRM && data?.offeringCountData?.map((e, index) => (
                                    <AGButtonV2
                                        iconRight={
                                            <RigthArrow className="ml-[10px] fill-[#0971A2]" />
                                        }
                                        onClick={() => handleLinkServiceOfFirm(e.offeringType?.offeringTypeName?.split(" ").join("").toLowerCase() || "")}
                                    >
                                        <p className={`text-[12px] font-normal text-[#0971A2] truncate max-w-[137px]`}>
                                            <span className="font-bold">{e.offeringCount}</span> {" "}
                                            {e.offeringType?.offeringTypeName}{(e.offeringCount && e.offeringCount > 1) && 's'}
                                        </p>
                                    </AGButtonV2>
                                ))
                            }

                            {
                                (tabType === ServiceItemType.SERVICE || tabType === ServiceItemType.PRODUCT) && data?.services?.sort((a, b) => {
                                    return a.comOfferingPracticeLevels?.[0]
                                        ? a.comOfferingPracticeLevels?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName.localeCompare(b.comOfferingPracticeLevels?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName)
                                        : a.comOfferingProductSecondaryServices?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName.localeCompare(b.comOfferingProductSecondaryServices?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName);
                                }).slice(0, 4).map((e, index) => (
                                    <AGButtonV2
                                        key={index}
                                        iconRight={
                                            <RigthArrow className="ml-[4px] customDesktop:group-hover:fill-white fill-[#0971A2]" />
                                        }
                                        witdh="137px"
                                        onClick={() => {
                                            handleLinkServiceOfService((tabType ?? "service").toLowerCase(), e.comOfferingPracticeLevels?.[0]?.fkComOfferingId ?? e.comOfferingProductSecondaryServices?.[0]?.fkComOfferingId)
                                        }
                                        }
                                        title={e.comOfferingPracticeLevels?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName ?? e.comOfferingProductSecondaryServices?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName}
                                    >
                                        <p className={`text-[12px] font-normal text-[#0971A2] customDesktop:group-hover:text-white customDesktop:group-hover:bg-[#0971A2]  truncate max-w-[137px]`}>
                                            {e.comOfferingPracticeLevels?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName ?? e.comOfferingProductSecondaryServices?.[0]?.fkSecondaryService?.fkMainOffering?.mainServiceName}
                                        </p>
                                    </AGButtonV2>
                                ))
                            }

                            {
                                (tabType === ServiceItemType.SECONDMENT) && data?.services?.slice(0, getShowMoreData()).map((e, index) => (
                                    <AGButtonV2
                                        key={index}
                                        iconRight={
                                            <RigthArrow className=" customDesktop:group-hover:fill-white fill-[#0971A2]" />
                                        }
                                        witdh="220px"
                                        onClick={() => {
                                            handleLinkServiceOfService((tabType ?? "service").toLowerCase(), e.comOfferingSecondments?.[0]?.fkComOfferingId ?? e.comOfferingSecondments?.[0]?.fkComOfferingId)
                                        }
                                        }
                                        cusInterestType={true}
                                        title={e.title}
                                    >
                                        <div className="absolute flex items-center justify-center left-[8px] ">
                                            <p className="text-[12px] w-[20px] font-bold text-center align-middle">
                                                {getInterestTypesById(e.comOfferingSecondmentInterestTypes ?? [])}
                                            </p>
                                            <span className="border-l border-[#0971A2] h-9 ml-[5px]" style={{ minHeight: 36 }}></span>
                                        </div>
                                        <p className={`ml-[20px] w-[200px] text-[12px] font-normal text-[#0971A2] flex min-w-0 items-center justify-center`}>
                                            <span className="truncate min-w-0 flex-shrink-0 max-w-[100%] text-center text-justify text-right">{e.title}</span>
                                        </p>
                                    </AGButtonV2>
                                ))
                            }

                            {
                                (tabType === ServiceItemType.SERVICE || tabType === ServiceItemType.PRODUCT || tabType === ServiceItemType.SECONDMENT) && data?.services && data?.services?.length > getShowMoreData() ? (
                                    <button
                                        className=" text-[12px] text-[#333333] underline whitespace-nowrap inline-block"
                                        onClick={() => {
                                            handleLinkServiceOfFirm(tabType)
                                        }}
                                    >
                                        Show {data?.services?.length - getShowMoreData()} more
                                    </button>
                                ) : null
                            }
                        </div>
                    </div>
                    : null
            }
        </Container >
    );
};
